import {css} from "styled-components"

export interface SpacingProps {
  margin?: boolean | string | number | (number | string)[]
  marginTop?: boolean | string | number
  marginRight?: boolean | string | number
  marginBottom?: boolean | string | number
  marginLeft?: boolean | string | number
  padding?: boolean | string | number | (number | string)[]
  paddingTop?: boolean | string | number
  paddingRight?: boolean | string | number
  paddingBottom?: boolean | string | number
  paddingLeft?: boolean | string | number
  gap?: boolean | string | number
}

export interface SizingProps {
  height?: string
  minHeight?: string
  maxHeight?: string
  width?: string
  minWidth?: string
  maxWidth?: string
}

const getValue = (theme: any, value: boolean | string | number | number[] | (string | number)[]) => {
  const {stepSize} = theme.spacing

  switch (typeof value) {
    case "object":
      if (value.length <= 4) {
        let string = ""
        value.forEach((val: number | string) => {
          string += typeof val === "string" ? `${val} ` : `${stepSize * val}px `
        })
        return string.substring(0, string.length - 1)
      }
      return null
    case "string":
      return value
    case "number":
      return `${stepSize * value}px`
    default:
      return theme.spacing.one
  }
}

export const spacingCss = css<SpacingProps>`
  ${({
    theme,
    margin,
    marginTop,
    marginRight,
    marginBottom,
    marginLeft,
    padding,
    paddingTop,
    paddingRight,
    paddingBottom,
    paddingLeft,
    gap
  }) => css`
    ${marginTop && `margin-top: ${getValue(theme, marginTop)};`}
    ${marginRight && `margin-right: ${getValue(theme, marginRight)};`}
    ${marginBottom && `margin-bottom: ${getValue(theme, marginBottom)};`}
    ${marginLeft && `margin-left: ${getValue(theme, marginLeft)};`}
    ${margin && `margin: ${getValue(theme, margin)};`}

    ${paddingTop && `padding-top: ${getValue(theme, paddingTop)};`}
    ${paddingRight && `padding-right: ${getValue(theme, paddingRight)};`}
    ${paddingBottom && `padding-bottom: ${getValue(theme, paddingBottom)};`}
    ${paddingLeft && `padding-left: ${getValue(theme, paddingLeft)};`}
    ${padding && `padding: ${getValue(theme, padding)};`}
    ${gap && `gap: ${getValue(theme, gap)};`}
  `}
`

export const sizingCss = css<SizingProps>`
  ${({height, minHeight, maxHeight, width, minWidth, maxWidth}) => css`
    ${height &&
    css`
      height: ${height};
    `}
    ${minHeight &&
    css`
      min-height: ${minHeight};
    `}
    ${maxHeight &&
    css`
      max-height: ${maxHeight};
    `}
    ${width &&
    css`
      width: ${width};
    `}
    ${minWidth &&
    css`
      min-width: ${minWidth};
    `}
    ${maxWidth &&
    css`
      max-width: ${maxWidth};
    `}
  `}
`
